import Image from 'next/image';
import { be } from 'models/conent';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FC } from 'react';
import { CustomerProps } from '@pages/e-signature';

interface Props {
  contents: CustomerProps[];
}

const CustomerSection: FC<Props> = ({ contents }) => {
  const { ref, inView } = useInView({ threshold: 0.5, triggerOnce: true });

  return (
    <section id="e-signature-customer" className="Container relative w-full">
      <h1 className="Container relative text-h5MobileBold lg:text-h5Bold gradient-head text-center pt-10 pb-2">
        TRUSTED BY
      </h1>

      <div
        ref={ref}
        className="grid grid-cols-3 lg:grid-cols-4 gap-x-4 md:gap-x-10 lg:px-48"
      >
        {contents?.map((logo, i) => (
          <motion.div
            key={i}
            className="p-4 self-center max-w-[7rem] md:max-w-[9rem] last:col-start-2 lg:last:col-auto mx-auto"
            initial="initial"
            animate="animate"
            custom={i}
            variants={{
              initial: { opacity: 0, y: 20 },
              animate: (i: any) =>
                inView
                  ? {
                      opacity: 1,
                      y: 0,
                      transition: {
                        delay: 0.35 + i * 0.08,
                        duration: 0.5,
                      },
                    }
                  : { opacity: 0, y: 20 },
            }}
          >
            <div className="h-auto w-full">
              <Image
                src={`${be}${logo.url}`}
                alt={logo.alt}
                width={logo.width}
                height={logo.height}
              />
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default CustomerSection;
